import { render } from "./UcretsizEgitim.vue?vue&type=template&id=ad7b6d98&scoped=true"
import script from "./UcretsizEgitim.vue?vue&type=script&lang=js"
export * from "./UcretsizEgitim.vue?vue&type=script&lang=js"

import "./UcretsizEgitim.vue?vue&type=style&index=0&id=ad7b6d98&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ad7b6d98"]])

export default __exports__